import React from 'react';
import { View, Text } from 'react-native';
import styled from 'styled-components/native';
import CoreFocus from './CoreFocus.js';
import {
  WorkoutContainerText,
  WorkoutContainerHeaderThree,
  WorkoutTextSubHeader,
  WorkoutTextHeader
} from '../../../styles/common-styles.js';
import { useWindowDimensions } from '../../../hooks/useWindowDimensions';


function WorkoutTrainingPlan({coreFocuses}) {

  //////////console.log("WorkoutTrainingPlan render");


  ////console.log('coreFocuses?' , coreFocuses);
  const { width } = useWindowDimensions();

  return (
    <WorkoutPlanParent>
      <WorkoutTextSubHeader style={{marginBottom:10}}>WORKOUT</WorkoutTextSubHeader>
      <WorkoutTextHeader>Your Training Plan</WorkoutTextHeader>
      <WorkoutContainerHeaderThree style={{marginTop:4}}>Core Focus</WorkoutContainerHeaderThree>
      <WorkoutPlanFocusContainer screenWidth={width}>

        <WorkoutPlanFocusLeft screenWidth={width}>
          {coreFocuses.map((focus, index) => (
            <CoreFocus key={index} img={focus.img} title={focus.name}/>
          ))}

          {coreFocuses.length === 0 && (
            <WorkoutContainerText style={{width:300}}>You have not completed a workout yet!</WorkoutContainerText>
          )}

        </WorkoutPlanFocusLeft>

        <WorkoutPlanFocusRight screenWidth={width}>
          {/* <WorkoutContainerText>Explanation of your core focus here.</WorkoutContainerText> */}
        </WorkoutPlanFocusRight>

      </WorkoutPlanFocusContainer>
    </WorkoutPlanParent>
  );
}

export const WorkoutPlanParent = styled.View`
  width:100%;
  height:400px;
  max-width:400px;
  padding:30px;
  display:flex;
` 

export const WorkoutPlanFocusContainer = styled.View`
  width:100%;
  display:flex;
  align-items:center;
  justify-content:center;
  flex-direction: ${(props) => (props.screenWidth <= 350 ? 'column' : 'row')};
  flex-wrap:wrap;
  margin-top:15px;
`

export const WorkoutPlanFocusLeft = styled.View`
  flex:1;
  max-height:100px;
  display:flex;
  justify-content:flex-start;
  align-items:flex-start;
  flex-direction:row;
`

export const WorkoutPlanFocusRight = styled.View`
  flex:1;
  padding:10px;
  margin-left: ${(props) => (props.screenWidth <= 375 ? '30px' : '0px')};
  margin-top: ${(props) => (props.screenWidth <= 375 ? '30px' : '0px')};
`

export default WorkoutTrainingPlan;
